/**
 * Generates blobs from canvas
 *
 * @param canvas required to obtain dataURL, stores the image
 * @param type stores image type for dataURL for particular format encoding
 */

export default (canvas, type) =>
  fetch(canvas.toDataURL(type)).then((res) => res.blob());
